import Vue from 'vue';
import Router from 'vue-router';
import Tournament from "./views/Tournament.vue";
import Tournaments from './views/Tournaments.vue';
import TournamentEdit from './views/TournamentEdit.vue';
import TournamentTeams from './views/TournamentTeams.vue';
import TournamentTeamEdit from './views/TournamentTeamEdit.vue';
import Login from './views/Login.vue';
import TournamentEventEdit from "./views/TournamentEventEdit.vue";
import TournamentEventEntryEdit from "./views/TournamentEventEntryEdit.vue";
import TournamentEvents from "./views/TournamentEvents.vue";
import TournamentRankings from "./views/TournamentRankings.vue";
import TournamentEventEntries from "./views/TournamentEventEntries.vue";
import TournamentEventDrawEdit from "./views/TournamentEventDrawEdit.vue";
import TournamentEventDraws from "./views/TournamentEventDraws.vue";
import TournamentMatches from "./views/TournamentMatches.vue";
import TournamentMatchScheduler from "./views/TournamentMatchScheduler.vue";
import TournamentEventSmartGenerator from "./views/TournamentEventSmartGenerator.vue";

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/tournaments'
    },

    {
      path: '/tournaments',
      name: 'tournaments',
      component: Tournaments
    },

    {
      path: '/tournaments/add',
      name: 'tournament-add',
      component: TournamentEdit
    },

    {
      path: '/tournaments/:tournament/edit',
      name: 'tournament-edit',
      component: TournamentEdit
    },

    {
      path: '/tournaments/:id',
      name: 'tournament',
      component: Tournament
    },

    {
      path: '/tournaments/:id/teams',
      name: 'tournament-teams',
      component: TournamentTeams
    },

    {
      path: '/tournaments/:id/events',
      name: 'tournament-events',
      component: TournamentEvents
    },

    {
      path: '/tournaments/:id/rankings',
      name: 'tournament-rankings',
      component: TournamentRankings
    },

    {
      path: '/tournaments/:id/matches',
      name: 'tournament-matches',
      component: TournamentMatches
    },

    {
      path: '/tournaments/:id/scheduler',
      name: 'tournament-scheduler',
      component: TournamentMatchScheduler
    },

    {
      path: '/tournaments/:id/teams/add',
      name: 'tournament-teams-add',
      component: TournamentTeamEdit
    },

    {
      path: '/tournaments/:id/teams/:team/edit',
      name: 'tournament-teams-edit',
      component: TournamentTeamEdit
    },


    {
      path: '/tournaments/:id/events/add',
      name: 'tournament-events-add',
      component: TournamentEventEdit
    },

    {
      path: '/tournaments/:id/events/:event/edit',
      name: 'tournament-events-edit',
      component: TournamentEventEdit
    },

    {
      path: '/tournaments/:id/events/:event/entries',
      name: 'tournament-events-entries',
      component: TournamentEventEntries
    },

    {
      path: '/tournaments/:id/events/:event/entry/add',
      name: 'tournament-events-entry-add',
      component: TournamentEventEntryEdit
    },

    {
      path: '/tournaments/:id/events/:event/entry/:entry/edit',
      name: 'tournament-events-entry-edit',
      component: TournamentEventEntryEdit
    },


    {
      path: '/tournaments/:id/events/:event/draws',
      name: 'tournament-events-Draws',
      component: TournamentEventDraws
    },


    {
      path: '/tournaments/:id/events/:event/draw/add',
      name: 'tournament-events-draw-add',
      component: TournamentEventDrawEdit
    },

    {
      path: '/tournaments/:id/events/:event/draw/:draw/edit',
      name: 'tournament-events-draw-edit',
      component: TournamentEventDrawEdit
    },


    {
      path: '/tournaments/:id/events/:event/generator',
      name: 'tournament-events-generator',
      component: TournamentEventSmartGenerator
    },

    {
      path: '/auth/login',
      name: 'login',
      component: Login
    }
  ]
})
